import Vitals from "./Vitals";
import Complaints from "./Complaints";
import HandE from "./HandE";
import Medicines from "./Medicines";
import Advice from "./Advice";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import CustomVioletButton from "../../../../../../Component/DigitalMarketing/CustomVioletButton";
import CustomInput from "../../../../../../Component/DigitalMarketing/CustomInput";

import {
  useGetProceduresQuery,
  useAddPrescriptionsMutation,
  useUpdateNewPrescriptionMutation,
} from "../../../../../../Service/PatientList";
import { replaceUndersocreAndFormat } from "../../../../Utils/utils";
import Toast from "../../../../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../../../../hooks/digitalMarketing/useSnackbar";

const AddPrescriptions = (props: any) => {
  const {
    setView,
    viewPrescription,
    setShowAddPrescription,
    setEditMode,
    refetch,
  } = props;

  const { id } = useParams();

  const [formData, setFormData] = useState<any>({
    id: null,
    prescriptionTitle: "",
    pulseRate: "",
    bloodPressure: "",
    allergy: "",
    history: "",
    investigations: "",
    notes: "",
    complaints: "",
    hematoxylinEosins: "",
    prescriptionMaster: [],
    advice: "",
  });

  const [submit, setSubmit] = useState(false);
  const [checkedState, setCheckedState] = useState(true);

  const { open, message, openSnackBar, type } = useSnackbar();

  const { data: ProcedureData } = useGetProceduresQuery();

  const [
    addPrescriptions,
    { isLoading: addLoading, isSuccess: addSuccess, error: addError },
  ] = useAddPrescriptionsMutation();

  const [
    updatePrescription,
    { isLoading: updateLoading, isSuccess: updateSuccess, error: updateError },
  ] = useUpdateNewPrescriptionMutation();

  const procedureOptions = ProcedureData?.data?.map((m: any) => ({
    value: m.id,
    label: replaceUndersocreAndFormat(m.procedureTitle),
  }));

  // ✅ Pre-fill edit
  useEffect(() => {
    if (viewPrescription && viewPrescription.id) {
      setFormData({
        id: viewPrescription.id,
        prescriptionTitle: viewPrescription.prescriptionTitle || "",
        pulseRate: viewPrescription.pulseRate || "",
        bloodPressure: viewPrescription.bloodPressure || "",
        allergy: viewPrescription.allergy || "",
        history: viewPrescription.history || "",
        investigations: viewPrescription.investigations || "",
        notes: viewPrescription.notes || "",
        complaints: viewPrescription.complaints || "",
        hematoxylinEosins: viewPrescription.hematoxylinEosins || "",
        prescriptionMaster: viewPrescription.prescriptionMaster || [],
        advice: viewPrescription.advice || "",
      });
    }
  }, [viewPrescription]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmit(true);

    if (
      !formData.pulseRate ||
      !formData.prescriptionTitle ||
      !formData.bloodPressure
    ) {
      return;
    }

    // ✅ Prepare payload with all new fields
    const payload = {
      prescriptionTitle: formData.prescriptionTitle,
      pulseRate: formData.pulseRate,
      bloodPressure: formData.bloodPressure,
      allergy: formData.allergy,
      history: formData.history,
      investigations: formData.investigations,
      notes: formData.notes,
      complaints: formData.complaints,
      hematoxylinEosins: formData.hematoxylinEosins,
      prescriptionMaster: formData.prescriptionMaster?.map((m: any) => ({
        medicineId: m.medicineId,
        medicineName: m.medicineName,
        medicineDosage: m.medicineDosage,
        medicineIntake: m.medicineIntake,
        inTake: m.inTake,
        medicineDays: m.medicineDays,
      })),
      advice: formData.advice,
      activeStatus: 1,
      customerId: id,
      priorityLevel: checkedState ? "urgent" : "routine",
    };

    if (formData?.id) {
      await updatePrescription({ id: formData.id, data: payload });
    } else {
      await addPrescriptions(payload);
    }
  };

  // ✅ Success handling
  useEffect(() => {
    if (addSuccess || updateSuccess) {
      toast.success("Prescription saved successfully!");
      setShowAddPrescription(false);
      setEditMode(false);
      setView(false);
      refetch(); // 🔄 refresh prescription list
    }
  }, [addSuccess, updateSuccess]);

  // ✅ Error handling
  useEffect(() => {
    if (addError || updateError) {
      const error: any = addError || updateError;
      toast.error(error?.data?.message || "Something went wrong!");
    }
  }, [addError, updateError]);

  return (
    <div className="p-2" style={{ maxHeight: "80vh", overflowY: "auto" }}>
      <div>
        <span className="f-18 fw-500 fw-bold">
          {formData?.id ? "Edit Prescription" : "New Prescription"}
        </span>
      </div>
      <Toast open={open} type={type} message={message} />

      <div className="row">
        <CustomInput
          label="Procedure"
          type="select"
          option={procedureOptions}
          labelKey="label"
          valueKey="value"
          // validation="required"
          submit={submit}
          name="prescriptionTitle"
          value={formData.prescriptionTitle}
          onChange={handleChange}
          setFormData={setFormData}
        />
      </div>

      {/* ✅ Updated Vitals includes allergy, history, investigations, notes */}
      <Vitals
        formData={formData}
        setFormData={setFormData}
        handleChange={handleChange}
        submit={submit}
      />

      <Complaints
        formData={formData}
        setFormData={setFormData}
        handleChange={handleChange}
        submit={submit}
      />
      <HandE
        formData={formData}
        setFormData={setFormData}
        handleChange={handleChange}
        submit={submit}
      />
      <Medicines
        formData={formData}
        setFormData={setFormData}
        submit={submit}
      />
      <Advice
        formData={formData}
        setFormData={setFormData}
        handleChange={handleChange}
        submit={submit}
      />

      <div className="mt-3">
        <CustomVioletButton
          btnLabel={formData?.id ? "Update" : "Save"}
          onClick={handleSubmit}
          isLoading={addLoading || updateLoading}
        />
      </div>
    </div>
  );
};

export default AddPrescriptions;
